<template>
  <v-row>
    <v-col cols="12" sm="6" class="mx-auto">
      <v-switch
        :label="$t('table.auto_accept_order')"
        :true-value="1"
        :false-value="0"
        v-model="form.auto_accept_order"
      ></v-switch>
    </v-col>

    <v-col cols="12" sm="6" class="mx-auto">
      <v-switch
        :label="$t('table.visible')"
        :true-value="1"
        :false-value="0"
        v-model="form.visible"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.car_classification"
        name="car_classification"
        attribute="fields.car_classification"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-select
            clearable
            dense
            outlined
            v-bind="attrs"
            v-on="listeners"
            :items="car_classifications"
            item-text="name"
            item-value="id"
            v-model="form.car_classification"
            :messages="$t('required')"
          ></v-select>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.tourism_city"
        name="tourism_city"
        attribute="fields.tourism_city"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-autocomplete
            clearable
            :items="tourismCities"
            item-text="name"
            item-value="id"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.tourism_city"
            :messages="$t('required')"
          ></v-autocomplete>
        </template>
      </form-group>
    </v-col>

    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.duration_in_hours"
        name="duration_in_hours"
        attribute="fields.duration_in_hours"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            clearable
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.duration_in_hours"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.max_allowed_km"
        name="max_allowed_km"
        attribute="fields.max_allowed_km"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            clearable
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.max_allowed_km"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.cancel_before_start_in_hours"
        name="cancel_before_start_in_hours"
        attribute="fields.cancel_before_start_in_hours"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            clearable
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.cancel_before_start_in_hours"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.reserve_before_start_in_hours"
        name="reserve_before_start_in_hours"
        attribute="fields.reserve_before_start_in_hours"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            clearable
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.reserve_before_start_in_hours"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.price"
        name="price"
        attribute="fields.price"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            clearable
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.price"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.return_pct"
        name="return_pct"
        attribute="fields.return_pct"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            clearable
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.return_pct"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FirstStep",
  props: {
    car_classifications: {
      type: Array,
      default: () => []
    },
    tourismCities: {
      type: Array,
      default: () => []
    },

    form: {
      type: Object,
      default: () => {}
    },

    isEdit: {
      type: Boolean,
      default: false
    }
  },
  inject: ["$v"],
  data() {
    return {
      menu: null
    };
  }
};
</script>
